import React from 'react';
import { Square, Stack } from '@grubhubprod/gh-cookbook-react';

export interface ISidePanelProps {
  children: JSX.Element | JSX.Element[];
}

export function SidePanel({ children }: ISidePanelProps): JSX.Element {
  return (
    <Stack x="xx-lg">
      <Square>{children}</Square>
    </Stack>
  );
}
